import { FormControl, Input, Stack } from "@chakra-ui/react"
import { ErrorMessage, Formik } from "formik"
import { ComponentProps, FC } from "react"
import { ErrorMessageField } from "src/components/ui"
import { DrawerForm } from "src/components/ui/DrawerForm"
import { InputLabel } from "src/components/ui/InputLabel"
import { FormikOnSubmit } from "src/utils/types"
import { IUserPasswordUpdateFormFields } from "."

interface Props extends Omit<ComponentProps<typeof DrawerForm>, "children"> {
	handleSubmit: FormikOnSubmit<IUserPasswordUpdateFormFields>
}

export const UserPasswordUpdateDrawerFormView: FC<Props> = ({
	handleSubmit,
	...rest
}) => (
	<Formik<IUserPasswordUpdateFormFields>
		initialValues={{ currentPassword: "", newPassword: "", newPasswordConfirm: "" }}
		onSubmit={handleSubmit}
		enableReinitialize={true}
	>
		{({ values, isSubmitting, handleChange }) => (
			<DrawerForm
				size="sm"
				headerLabel="Update Password"
				submitLabel="Save"
				isSubmitting={isSubmitting}
				{...rest}
			>
				<Stack maxWidth={"sm"} marginX={"auto"}>
					{/* Current Password */}
					<FormControl>
						<InputLabel label="Current Password" />
						<Input
							name="currentPassword"
							placeholder="Current Password"
							maxLength={50}
							required
							autoFocus
							value={values.currentPassword}
							onChange={handleChange}
							type="password"
						/>
					</FormControl>
					{/* New Password */}
					<FormControl>
						<InputLabel label="New Password" />
						<Input
							name="newPassword"
							placeholder="New Password"
							maxLength={50}
							required
							value={values.newPassword}
							onChange={handleChange}
							type="password"
						/>
					</FormControl>
					{/* New Password Confirm */}
					<FormControl>
						<InputLabel label="Confirm New Password" />
						<Input
							name="newPasswordConfirm"
							placeholder="Confirm New Password"
							maxLength={50}
							required
							value={values.newPasswordConfirm}
							onChange={handleChange}
							type="password"
						/>
						<ErrorMessage
							component={ErrorMessageField}
							name="newPasswordConfirm"
						/>
					</FormControl>
				</Stack>
			</DrawerForm>
		)}
	</Formik>
)
